import React, { useEffect, useContext } from 'react'
import { withTranslationCustom } from 'lib/i18next'
import { wrapEvent } from 'lib/utils/store/wrappers/event/Event'
import { EVENT_REMINDER_OPTIONS, EVENT_TYPE } from 'lib/utils/store/event'

import EventFormModule, {
    EventFormModuleLeftRightContainer,
    EventFormModuleLeft,
    EventFormModuleRight,
} from 'components/Events/EventForm/EventFormModules/EventFormModule'
import Icon from 'components/Icon'
import EventReminders from './EventReminders/EventReminders/EventReminders'
import EventReminderTopic from './EventReminders/EventReminderTopic/EventReminderTopic'
import { ExtendedFormikContext } from 'components/Forms/ExtendedFormik'

import './event-form-reminder-module.pcss'

const EventFormReminderModule = ({ t, module }) => {
    const { setFieldValue, values, initialValues } = useContext(ExtendedFormikContext)

    useEffect(() => {
        if (initialValues.remindBefore && initialValues.remindBefore.length) {
            setFieldValue('remindBefore', initialValues.remindBefore)
        } else {
            const defaultReminderIndex = values.type === EVENT_TYPE.INSPECTION
                ? 6 // one month before
                : 2 // one day before

            setFieldValue('remindBefore', [EVENT_REMINDER_OPTIONS[defaultReminderIndex].value])
        }

        const reminderTopic = initialValues.reminderTopic
            ? initialValues.reminderTopic
            : wrapEvent({ type: values.type }).getDefaultTitle(t)

        setFieldValue('reminderTopic', reminderTopic)

        return () => {
            setFieldValue('remindBefore', [])
            setFieldValue('reminderTopic', '')
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <EventFormModule className="event-form-reminder-module" expanded={true}>
            <EventFormModuleLeftRightContainer>
                <EventFormModuleLeft>
                    <Icon fa name={module.icon} color="#b1b1b1" />
                </EventFormModuleLeft>
                <EventFormModuleRight>
                    <EventReminders fieldName="remindBefore" />
                    <EventReminderTopic
                        fieldName="reminderTopic"
                        label={t('events:reminders.title')}
                    />
                </EventFormModuleRight>
            </EventFormModuleLeftRightContainer>
        </EventFormModule>
    )
}

export default withTranslationCustom('events')(EventFormReminderModule)
